export default __webpack_public_path__ + "static/media/food-for-environment-vegshelf.6e2da559.png";